import { render, staticRenderFns } from "./Document_reduce_debt.vue?vue&type=template&id=e5a38672&scoped=true&"
import script from "./Document_reduce_debt.vue?vue&type=script&lang=js&"
export * from "./Document_reduce_debt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a38672",
  null
  
)

export default component.exports